module.exports = __webpack_public_path__ + "img/yahoo-mail.png";